// FNP-585: read-only binding-drift sweep history. Two queries, both backed by the
// FNP-584 read-model on billing-api. listBindingDriftReports is Query-backed on the
// recordType-runStartedAt GSI (newest-first), never a Scan.
//
// Each query selects only what its view renders (§11): the list shows the run start
// and the outcome counts; the detail adds the run day, completion time and findings.

export const listBindingDriftReports = `
   query listBindingDriftReports($limit: Int, $nextToken: String) {
       listBindingDriftReports(limit: $limit, nextToken: $nextToken) {
           items {
              id
              runStartedAt
              accountsScanned
              driftDetectedCount
              repairedCount
              repairFailedCount
              repairCappedCount
           }
           nextToken
       }
   }
`;

export const getBindingDriftReport = `
   query getBindingDriftReport($id: ID!) {
       getBindingDriftReport(id: $id) {
         id
         runDate
         runStartedAt
         runCompletedAt
         accountsScanned
         driftDetectedCount
         repairedCount
         repairFailedCount
         repairCappedCount
         findings
         findingsS3Uri
       }
}`;
